module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms15e-detail3Info"
    }
  }, [(_vm.detail3InfoDesc1Disp) ? [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "main-topic-box"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.lov.grditem.loading),
      expression: "!lov.grditem.loading"
    }],
    staticClass: "left-arrow fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.triggerSetDetail3InfoSelected(-1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC10']['40']) + " " + _vm._s(_vm.detail3Info.rows[_vm.detailIndex].kpino))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.lov.grditem.loading),
      expression: "!lov.grditem.loading"
    }],
    staticClass: "right-arrow fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.triggerSetDetail3InfoSelected(1)
      }
    }
  })]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC6']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail3Info.rows[_vm.detailIndex].kpino))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC6']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    staticClass: "form-control readonly-field-color",
    attrs: {
      "readonly": ""
    }
  }, [_vm._v(_vm._s(_vm.detail3Info.rows[_vm.detailIndex].kpiitem))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC6']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail3Info.rows[_vm.detailIndex].target),
      expression: "detail3Info.rows[detailIndex].target"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:200'),
      expression: "'max:200'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": false || _vm.detail3Desc1Disp || _vm.detail3Desc2Disp,
      "maxlength": "200",
      "id": "detail3InfoTargetId",
      "data-vv-name": "target",
      "has-error": _vm.errors.has('target')
    },
    domProps: {
      "value": (_vm.detail3Info.rows[_vm.detailIndex].target)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail3Info.rows[_vm.detailIndex], "target", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('target')),
      expression: "errors.has('target')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('target')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(200)))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC6']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail3Info.rows[_vm.detailIndex].achieve),
      expression: "detail3Info.rows[detailIndex].achieve"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:600'),
      expression: "'max:600'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": false || _vm.detail3Desc1Disp || _vm.detail3Desc2Disp,
      "maxlength": "600",
      "data-vv-name": "achieve",
      "has-error": _vm.errors.has('achieve')
    },
    domProps: {
      "value": (_vm.detail3Info.rows[_vm.detailIndex].achieve)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail3Info.rows[_vm.detailIndex], "achieve", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('achieve')),
      expression: "errors.has('achieve')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('achieve')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(600)))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC6']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail3Info.rows[_vm.detailIndex].v_mtrunit))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC6']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail3Info.rows[_vm.detailIndex].mtrvalue))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC6']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail3Info.rows[_vm.detailIndex].v_mtrvalue))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC6']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('hrms-dropdown', {
    attrs: {
      "options": _vm.dropdowns.statuskpi[_vm.nowLang],
      "disabled": false || _vm.detail3Desc1Disp || _vm.detail3Desc2Disp
    },
    model: {
      value: (_vm.detail3Info.rows[_vm.detailIndex].status),
      callback: function($$v) {
        _vm.$set(_vm.detail3Info.rows[_vm.detailIndex], "status", $$v)
      },
      expression: "detail3Info.rows[detailIndex].status"
    }
  })], 1)])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC6']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('date_format:DD/MM/YYYY'),
      expression: "'date_format:DD/MM/YYYY'"
    }],
    attrs: {
      "disabled": false || _vm.detail3Desc1Disp || _vm.detail3Desc2Disp
    },
    model: {
      value: (_vm.detail3Info.rows[_vm.detailIndex].dtetargt),
      callback: function($$v) {
        _vm.$set(_vm.detail3Info.rows[_vm.detailIndex], "dtetargt", $$v)
      },
      expression: "detail3Info.rows[detailIndex].dtetargt"
    }
  })], 1)])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC6']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail3Info.rows[_vm.detailIndex].kpiwgt))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC6']['160']))]), _vm._v(" "), (_vm.detail3Info.rows[_vm.detailIndex].kpino !== '') ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('hrms-lov', {
    attrs: {
      "lovType": "grditem",
      "disabled": false || _vm.detail3Desc1Disp || _vm.detail3Desc2Disp,
      "nowLang": _vm.nowLang,
      "name": "grdscor"
    },
    on: {
      "setDataRow": _vm.triggerLovSelect,
      "fineDescLov": _vm.setQtyScore
    },
    model: {
      value: (_vm.detail3Info.rows[_vm.detailIndex].grdscor),
      callback: function($$v) {
        _vm.$set(_vm.detail3Info.rows[_vm.detailIndex], "grdscor", $$v)
      },
      expression: "detail3Info.rows[detailIndex].grdscor"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.getFormat(_vm.detail3Info.rows[_vm.detailIndex].qtyscor)))])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-12 "
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC6']['190']))])]), _vm._v(" "), _c('hrms-table', {
    ref: "detail3InfoTable",
    attrs: {
      "columns": _vm.detail3InfoTable,
      "data": {
        total: _vm.detail3Info.rows[_vm.detailIndex].table.length,
        rows: _vm.detail3Info.rows[_vm.detailIndex].table
      },
      "addInlineEventBool": true && !_vm.detail3Desc1Disp && !_vm.detail3Desc2Disp && _vm.validateStaappr,
      "editInlineEventBool": true && !_vm.detail3Desc1Disp && !_vm.detail3Desc2Disp,
      "deleteInlineEventBool": true && !_vm.detail3Desc1Disp && !_vm.detail3Desc2Disp,
      "deleteInlineBtnDisp": false,
      "saveInlineEvent": _vm.callSave,
      "saveInlineBtnDisp": false,
      "indexDisp": false,
      "searchDisp": false,
      "columnEvent": _vm.columnEvent
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.detail3Desc1Disp && !_vm.detail3Desc2Disp),
      expression: "!detail3Desc1Disp && !detail3Desc2Disp"
    }],
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-md-6 clear-padding"
  }, [(_vm.validateStaappr) ? _c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.postDetail3Info()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 clear-padding"
  }, [_c('div', {
    staticClass: "dropup",
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "id": "dropdownMenu2",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.labels['HRAP31EC3']['320']) + "\n              "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right",
    attrs: {
      "aria-labelledby": "dropdownMenu2"
    }
  }, [_c('li', {
    staticClass: "cursor-pointer"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.courseRequired()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC6']['220']))])]), _vm._v(" "), _c('li', {
    staticClass: "cursor-pointer"
  }, [_c('a', {
    attrs: {
      "data-toggle": "modal",
      "href": "#hrms15e-popup3-desc2"
    },
    on: {
      "click": function($event) {
        _vm.detailWork()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC6']['230']))])])])])])])], 1)] : [_c('detail3InfoDesc1', {
    attrs: {
      "labels": _vm.labels,
      "searchIndex": _vm.searchIndex,
      "indexSelected": _vm.indexSelected,
      "detail": _vm.detailCourse,
      "detail3InfoDesc1Table": _vm.detail3InfoDesc1Table,
      "nowLang": _vm.nowLang,
      "receivedHrms15eDetailCourseAddInline": _vm.receivedHrms15eDetailCourseAddInline,
      "postDetailCourseSave": _vm.postDetailCourseSave,
      "validateStaappr": _vm.validateStaappr
    }
  })], _vm._v(" "), _c('popup', {
    attrs: {
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "nowLang": _vm.nowLang,
      "data": _vm.popupDetail3InfoDesc2,
      "detail3InfoDesc2PopupTable": _vm.detail3InfoDesc2PopupTable,
      "receivedHrms15eDetail3InfoDesc2Popup": _vm.receivedHrms15eDetail3InfoDesc2Popup
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f40c82a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms15e/detail3Info.vue
// module id = 3850
// module chunks = 1